<template>
	<router-view/>
</template>
<script>
export default {
	data() {
		return {
			queryCID: ''
		}
	},
	watch:{
		$route (to,from){

			if(to.query.cid){
				this.queryCID = '?cid=' + to.query.cid
			}

			if(from.query.cid){
				this.queryCID = '?cid=' + from.query.cid
			}

			// var query_tracking = from.query.cid || ''
			// if(!to.query.cid && this.queryCID =={
			// 	this.queryCID = '?cid=' + query_tracking
			// } 
			

			if(from.name !== 'Title Screen Index'){
				this.trackingPage(to)
			} else if(from.name === 'Title Screen Index' && to.name !== 'Title Screen Index') {
				// prevent tracking auto rotate of additional slides
				this.trackingPage(to)
			}
		}
	},
	methods: {
		trackingPage(to){

			let the_url = window.location.hostname.split('.'),
				the_domain = window.location.hostname,
				the_subdomain = '' 

			if(the_url.length > 2){
				the_subdomain = the_url.shift() 
			}

			var aml_cll = {
				pierce: 'aml',
				carson: 'aml',
				neutropenia: 'aml',
				bishop: 'cll',
				gordon:  'cll',
				calendars:  'cll'
			}

			var page_name = null

			switch(to.path){
				case '/title-screen/1':
					page_name = 'Home'
				break

				case '/aml-cll/intro/pierce':
					page_name = 'Initiation and Response assessment'
				break

				case '/aml-cll/intro/carson':
					page_name = 'Grade 4 Neutropenia'
				break

				case '/aml-cll/intro/neutropenia':
					page_name = 'Neutropenia Management Center'
				break

				case '/aml-cll/intro/bishop':
					page_name = 'Initiation for CLL'
				break

				case '/aml-cll/intro/gordon':
					page_name = 'Grade 4 Neutropenia'
				break

				case '/aml-cll/intro/calendars':
					page_name = 'Sample Initiation Calendars'
				break
			}

			window.digitalData = {} //clear anything previous
			window.digitalData = {
				page: {
					pageInfo: {
						domain: the_domain,
						subDomain: the_subdomain,
						url: window.location.href + this.queryCID,
						path: to.path ? to.path : '',
						pageName: page_name ? page_name : to.name,
					//	title: to.name ? to.name + (to.params.which ? ' - ' + (to.params.which).toUpperCase()  : '') : '',
						title: document.title,
						prefix: 'oncologyexplorer'
					},
					category: {
						primaryCategory: '',
						subCategory1: '',
						subCategory2: ''
					},
					attributes: {
						country: 'US',
						language: 'en-US',
						template: '',
						promoMatsNumber: 'BCL2-US-00229-E, v2.0',
						globalISI: '',
						type: 'Product Information'
					},
					journey: {
						content: '',
						patient: '',
						messageBucket: 'Support & Resources'
					},
					product: {
						name: 'venetoclax',
						franchise: 'onc',
						indication: aml_cll[to.params.which] ? aml_cll[to.params.which] : 'cross',
						division: 'Oncology',
						brand: 'Venclexta'
					},
					site: {
						type: 'Unbranded',
						experience: 'Product',
						audience: 'HCP'
					},
					modal: {
						type: '',
						name: '',
						position: '',
						enabled: '',
						displayed: ''
					},
					search: {
						autoPosition: '',
						term: '',
						count: '',
						type: '',
						filterType: '',
						filterValue: '',
						filterCategory: '',
						sortByInit: '',
						origin: '',
						originURL: ''
					}
				},
				user: [{
					profile: [{
						id: {
							crmID: this.$store.getters.userInfo ? this.$store.getters.userInfo.toString() : '',
							transID: '',
							abbvieCustomerID: '',
							hcpAccountID: '',
							npiID: '',
							dmpID: '',
							adobeID: ''
						},
						attributes: {
							status: '',
							type: ''
						},
					}]
				}]
			}

			window.trackPage()

		}
	},
}
</script>
<style>
/*
YUI 3.18.1 (build f7e7bcb)
Copyright 2014 Yahoo! Inc. All rights reserved.
Licensed under the BSD License.
http://yuilibrary.com/license/
*/

html{color:#000;background:#FFF}body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:normal}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:normal}q:before,q:after{content:''}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,textarea,select{font-family:inherit;font-size:inherit;font-weight:inherit;*font-size:100%}legend{color:#000}

/* apply a natural box layout model to all elements, but allowing components to change */
html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}


html {
	font-size: 62.5%;
}

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.nav-slides {
	align-items: center;
}

.title-screens {
	background: url(assets/title-screens/background.png) no-repeat;
}

body {
	background-color: #ebedf0;
}

.title-screens {
	background-position: center;
}

.title-screens {
	background-size: cover;
}

#choices li em.arr {
	color: #1ac9a8;
}

.link {
	cursor: pointer;
}

#app,
.screen-container,
.screen-container > header,
#slide-container,
.nav-slides,
#nav-choices,
#nav-choices-main {
	display: flex;
}

.screen {
	display: grid;
}

.screen-container,
.slide-container,
#nav-choices {
	flex-direction: column;
}

#tc-nav li sup {
	font-size: 1rem;
}

#choices li em.arr {
	font-variant: normal;
}

#slide-container,
.nav-slides {
	justify-content: center;
}

.screen-container > header {
	justify-content: space-between;
}

.screen-container {
	margin: 0 auto;
}

.screen-container {
	max-width: 1024px;
}

.screen-container {
	max-height: 768px;
}

.screen-container {
	min-width: 1024px;
}

html,
body,
#app,
.screen {
	min-height: 100vh;
}

.screen-container {
	min-height: 240px;
}


#patient-container .screen-container {
	min-height: 615px;
}

#patient-container.patient-container-gordon .screen-container {
	min-height: 618px;
}

.screen {
	place-items: center;
}

#app,
.screen {
	width: 100vw;
}



#title-screens footer img + p,
#navigation footer p {
	display: none;
}
</style>
